import script from "./toolkitHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./toolkitHeader.vue?vue&type=script&setup=true&lang=js"

import "./toolkitHeader.vue?vue&type=style&index=0&id=96a0f13a&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96a0f13a"]])

export default __exports__